import React from 'react';

import ContentBuilt from './ContentBuilt';
import {IContentProps} from './IContent';

const Content = ({data, cloneSource = false}: IContentProps) => {
	// Check if it's already built before
	if (
		React.isValidElement(data)
		|| (Array.isArray(data)) && data.find((d) => React.isValidElement(d))
	) {
		return data;
	}

	return <ContentBuilt data={data} cloneSource={cloneSource} />;
};

export default Content;
